import firebase from 'firebase/app'
import config from '../store/modules/config'

import 'firebase/firestore'
import 'firebase/database'

export const convrrtV3 = firebase.initializeApp(config.state.firebase.convrrtV3)
export const convrrtV1 = firebase.initializeApp(config.state.firebase.convrrtV3, 'convrrt-1081')
